module.exports = __webpack_public_path__ + "img/reward.75a5a0e8.svg";